import React, { useEffect } from "react";
import { languageHelper } from "../../config/helperFunctions";

function POSOrderDetail({
  toggle,
  orderDetails,
  setShowFinalizeOrderModal,
  setPayAmount,
  setTotalPayableFinal
}) {
  const orderItems = orderDetails.order_details;
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);
  return (
    <div
      className="fixed top-0 left-0 z-10 h-screen w-full overflow-y-scroll bg-black bg-opacity-50 backdrop-blur-md grid place-items-center p-4"
      onClick={() => toggle()}
    >
      <div
        className="max-w-lg w-full py-2 px-6 rounded-lg bg-white space-y-2 min-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <h1 className="text-center font-medium">{languageHelper(defaultLang, "Order Details")}</h1>
        <div className="grid grid-cols-3 gap-1 text-xs">
          <div>
            <strong>{languageHelper(defaultLang, "Order Type")}:</strong> {orderDetails.order_type?.type}
          </div>
          <div>
            <strong>{languageHelper(defaultLang, "Order Number")}:</strong> {orderDetails.sale_no}
          </div>
          <div>
            <strong>{languageHelper(defaultLang, "Phone")}:</strong> {orderDetails.customer?.phone}
          </div>
          <div>
            <strong>{languageHelper(defaultLang, "Waiter")}:</strong> {orderDetails.waiter_name}
          </div>
          <div>
            <strong>{languageHelper(defaultLang, "Customer")}:</strong> {orderDetails.customer?.name}
          </div>
          <div>
            <strong>{languageHelper(defaultLang, "Table")}:</strong> {orderDetails.table_name || "None"}
          </div>
        </div>

        <div className="relative overflow-x-auto flex-1 overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right">
            <thead className="text-xs text-white bg-d-bg">
              <tr>
                <th scope="col" className="px-2 py-1">
                  {languageHelper(defaultLang, "Item")}
                </th>
                <th scope="col" className="px-2 py-1">
                  {languageHelper(defaultLang, "Price")}
                </th>
                <th scope="col" className="px-2 py-1">
                  {languageHelper(defaultLang, "Qty")}
                </th>
                <th scope="col" className="px-2 py-1">
                  {languageHelper(defaultLang, "Total")}
                </th>
              </tr>
            </thead>
            <tbody>
              {orderItems.map((item, index) => (
                <tr className="bg-white" key={index}>
                  <th
                    scope="row"
                    className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap"
                  >
                    {item.name}
                  </th>
                  <td className="px-2 py-1">
                    SAR - {item.menu_price_with_discount}
                  </td>
                  <td className="px-2 py-1">{item.qty}</td>
                  <td className="px-2 py-1">
                    {item.menu_price_with_discount * item.qty}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-2 bg-gray-100 text-xs">
          <div className="grid grid-cols-10">
            <div className="col-span-4">
              <strong>{languageHelper(defaultLang, "Total Items")}:</strong>{" "}
              {orderItems.length}
            </div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Sub Total")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.sub_total || "0.00"}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Discount")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.total_discount_amount || "0.00"}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "VAT")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.vat_amount || "0.00"}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Product Discount")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.total_item_discount_amount}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Coupon Discount")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.coupon_discount_amount}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Total Discount")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.total_discount_amount}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Service/Delivery Charges")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.delivery_charges}
            </div>
            <div className="col-span-4"></div>
            <div className="col-span-4 text-right">
              <strong>{languageHelper(defaultLang, "Total Payable")}</strong>
            </div>
            <div className="col-span-2 text-right">
              SR {orderDetails.total_payable}
            </div>
          </div>
        </div>

        <div className="text-xs space-y-2">
          <button
            onClick={() => {
              setPayAmount(orderDetails.total_payable);
              setTotalPayableFinal(orderDetails.total_payable);
              setShowFinalizeOrderModal(true);
            }}
            className="w-full bg-gray-200 flex gap-2 items-center justify-center p-2 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
            >
              <path d="M20 12v6a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6h-2zm-6-1v2H6v-2h8zM6 9V7h8v2H6zm8 6v2h-3v-2h3z"></path>
            </svg>
            <span>{languageHelper(defaultLang, "Create Invoice & Close")}</span>
          </button>
          <button
            className="bg-d-cat-btn text-white p-2 text-center w-full rounded-md"
            onClick={() => toggle()}
          >
            {languageHelper(defaultLang, "Back")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default POSOrderDetail;
